/**
 * NOVA-2210
 *
 * remove the `mapPopup` slice
 */
export default function (state) {
    const { mapPopup, ...rest } = state;

    return rest;
}
